import i18n from 'modules/core/lib/i18n'

export const translations = () => ({
  header: i18n.t('contract_versions.flows.update.steps.dates.request_header'),
  effective_date: i18n.t('contract_versions.flows.update.steps.dates.effective_date.label'),
  effective_date_tooltip: i18n.t(
    'contract_versions.flows.update.steps.dates.effective_date.tooltip'
  ),
  new_start_date_title: i18n.t('contract_versions.flows.fix.steps.dates.contract_start_date.title'),
  request_details: i18n.t('contract_versions.flows.fix.steps.dates.request_details'),
})
